import React from 'react';
import PropTypes from 'prop-types';
import RpCheckBoxGroup from 'components/commons/RpCheckBoxGroup';
import useFilterStore from 'zustandStore/useFilterStore';
import { VALUATION_CONFIDENCE } from 'constants/propertyTypes';
import { useSelector } from 'react-redux';

const ValuationConfidenceFilter = React.memo(function ValuationConfidenceFilter(props) {
    const estimateTooltip = useSelector(state => state.disclaimers.estimateTooltip);
    const valuationConfidenceValue = useFilterStore(state => state.filters[props.comparableType].latestConsumerSaleConfidence);
    const setFilters = useFilterStore(state => state.setFilters);

    const handleChange = (value) => {
        setFilters(props.comparableType, {
            latestConsumerSaleConfidence: valuationConfidenceValue.includes(value)
                ? valuationConfidenceValue.filter(v => v !== value)
                : [...valuationConfidenceValue, value]
        });
    };

    const clearAll = () => {
        setFilters(props.comparableType, { latestConsumerSaleConfidence: [] });
    };

    const selectAll = () => {
        setFilters(props.comparableType, { latestConsumerSaleConfidence: VALUATION_CONFIDENCE?.map(o => o.value) });
    };

    const allSelected = valuationConfidenceValue.length === VALUATION_CONFIDENCE?.length;
    const displayValue = allSelected ? '' : valuationConfidenceValue?.join(', ');

    return (
        <RpCheckBoxGroup
            label="Valuation Estimate Confidence"
            options={VALUATION_CONFIDENCE}
            value={valuationConfidenceValue}
            onChange={handleChange}
            clearAll={clearAll}
            selectAll={selectAll}
            displayValue={displayValue}
            active={!!displayValue}
            isDropdown={false}
            columnSize={props.columnSize || 2}
            tooltip={estimateTooltip}
            width={200}
        />
    );
});

ValuationConfidenceFilter.propTypes = {
    label: PropTypes.string,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
        })
    ),
    isDropdown: PropTypes.bool,
    comparableType: PropTypes.string.isRequired,
    columnSize: PropTypes.number,
};

export default ValuationConfidenceFilter;
